import React, { useContext } from 'react'
import Card from '../components/Card'
import { useLocation } from 'react-router-dom'
import { motion } from "framer-motion";
import { MyContext } from '../contexts/MyContext';
import { useTheme } from '../contexts/ThemeContext';

const Projects = () => {
    const location = useLocation();
    const [selectedTab, setSelectedTab] = React.useState("All");
    const {projects, projectCategory} = useContext(MyContext)
    const { isDark } = useTheme();

    React.useEffect(() => {
        if (location.state?.tab) {
            setSelectedTab(location.state.tab)
        }
    }, [location])

    const fetchedProject = selectedTab===projectCategory.all ? projects : projects.filter(a=> a.category.includes(selectedTab))

    return (
        <div className="w-full flex-1 pt-12 md:pt-20 pb-10 lg:pb-20">
            {/* Header */}
            <div className="flex flex-wrap justify-center">
                <div className="w-full px-4">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="text-center mx-auto mb-12 lg:mb-16 max-w-[510px]"
                    >
                        <h2 className={`font-mono font-bold text-3xl sm:text-4xl md:text-5xl mb-4 ${
                            isDark ? 'text-dark-text-primary' : 'text-light-text-primary'
                        }`}>
                            <span className={isDark ? 'text-dark-brand-primary' : 'text-light-brand-primary'}>
                                $
                            </span>
                            {' '}cat{' '}
                            <span className={isDark ? 'text-dark-brand-secondary' : 'text-light-brand-secondary'}>
                                ./all_projects
                            </span>
                        </h2>
                        <p className={`text-sm md:text-base font-mono ${
                            isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'
                        }`}>
                            <span className={isDark ? 'text-dark-brand-accent' : 'text-light-brand-accent'}>
                                //
                            </span>
                            {' '}Complete portfolio with source code on GitHub
                        </p>
                    </motion.div>
                </div>
            </div>

            {/* Category Tabs - Code editor style */}
            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.2 }}
                className='mx-auto w-full mb-12'
            >
                <div className={`flex flex-wrap justify-center items-center gap-2 p-2 rounded-lg border ${
                    isDark
                        ? 'bg-dark-bg-secondary border-dark-border'
                        : 'bg-light-bg-secondary border-light-border'
                }`}>
                    {Object.values(projectCategory).map((value, index) => {
                        const isSelected = selectedTab === value;
                        return (
                            <motion.button
                                key={index}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => setSelectedTab(value)}
                                className={`font-mono text-xs md:text-sm px-4 py-2 rounded-md transition-all ${
                                    isSelected
                                        ? (isDark
                                            ? 'bg-dark-brand-primary text-dark-bg-primary font-semibold'
                                            : 'bg-light-brand-primary text-white font-semibold')
                                        : (isDark
                                            ? 'text-dark-text-secondary hover:bg-dark-bg-tertiary hover:text-dark-brand-primary'
                                            : 'text-light-text-secondary hover:bg-light-bg-tertiary hover:text-light-brand-primary')
                                }`}
                            >
                                {isSelected && '> '}{value}
                            </motion.button>
                        )
                    })}
                </div>
            </motion.div>

            {/* Project Grid */}
            {
                fetchedProject.length !== 0 ?
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.4, delay: 0.3 }}
                    className="flex flex-wrap justify-center w-full gap-6 lg:gap-8"
                >
                    {fetchedProject?.map((item, index) => {
                        return (<Card item={item} index={index} selectedTab={selectedTab} key={index}/>)
                    })}
                </motion.div>
                :
                <div className={`flex flex-col items-center justify-center text-center py-20 ${
                    isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'
                }`}>
                    <div className="font-mono text-6xl mb-4">
                        {isDark ? '>' : '$'}_
                    </div>
                    <h1 className='text-2xl md:text-3xl font-mono font-bold mb-2'>
                        Loading projects...
                    </h1>
                    <p className="font-mono text-sm">
                        <span className={isDark ? 'text-dark-brand-accent' : 'text-light-brand-accent'}>
                            //
                        </span>
                        {' '}Fetching data from Firestore
                    </p>
                </div>
            }
        </div>
    )
}

export default Projects
